export default "__VITE_ASSET__e25280e5__"